import {useI18n} from '@yandex-delivery/core/i18n'
import {noop} from '@yandex-delivery/utils'

import type {BlockWithoutValuesAction} from '../../../../../../api'
import {useConfig} from '../../../../../../config'
import {useBlocksLayout} from '../../BlocksLayoutProvider'

export function useAction(action?: BlockWithoutValuesAction) {
  const {permissions, pathToOfferConfig} = useConfig()
  const i18n = useI18n()
  const {isMobile} = useBlocksLayout()

  const isActionAllowed = !action?.permission || permissions?.[action.permission]

  if (isMobile || !action || !isActionAllowed) {
    return
  }

  switch (action.type) {
    case 'go_to_strategy':
      return {
        title: i18n(`tariffs-v3.tariff-info.action.${action.type}`, 'Настройка вариантов доставки'),
        action: pathToOfferConfig ? () => void (window.location.href = pathToOfferConfig) : noop,
      }
  }
}
